import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'userManagementExperience.actionList'

const UserManagementUserActionListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default UserManagementUserActionListSlice
